import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import TiltExample from '../help/TiltExample';
import GameplayBackground from '../fbhop/GameplayBackground';

export default class InstructionScene extends Phaser.Scene {
  static get KEY() { return 'InstructionScene'; }

  constructor() {
    super({ key: InstructionScene.KEY });
  }

  create() {
    this.bg = new GameplayBackground(this);
    this.add.existing(this.bg);
    this.instructGroup = this.add.container();

    this.headerBg = ABCyaPhaser.Images.addImage(0, this.scale.height * 0.15, 'QuestionBg', this.instructGroup).setOrigin(0);

    this.headerTitle = this.add.bitmapText(this.scale.width * 0.5, this.headerBg.y + this.headerBg.height * 0.25, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('instructions.how_to_play'), 52).setOrigin(.5)
      .setTintFill(0x33a39e);

    this.instructGroup.add(this.headerTitle);

    // can be used to debug motion control setup
    // gameData.config.hasMotionControls = true;
    if (!gameData.config.hasMotionControls) {
      this.keySprites = ABCyaPhaser.Images.addImage(this.scale.width * 0.5, this.headerBg.y + this.headerBg.height, 'InstructArrows', this.instructGroup);
      this.keySprites.y = this.headerBg.y + this.headerBg.height - 4 + ~~(this.keySprites.height / 2);
      this.keySprites.visible = false;
      this.instructGroup.bringToTop(this.headerBg);
      this.instructGroup.bringToTop(this.headerTitle);

      this.leftInstruct = this.add.bitmapText(this.scale.width * 0.25, this.headerBg.y + this.headerBg.height * 0.68, 'QuicksandRegular', ABCyaPhaser.Localization.instance.getLocalizedString('instructions.tap_left'), 28, Phaser.GameObjects.BitmapText.ALIGN_RIGHT).setOrigin(0.5)
        .setTintFill(0x005472);
      this.instructGroup.add(this.leftInstruct);

      this.leftArrow = ABCyaPhaser.Images.addImage(this.scale.width * 0.25, this.headerBg.y + this.headerBg.height * 0.75, 'Arrow_Left', this.instructGroup);

      this.rightInstruct = this.add.bitmapText(this.scale.width * 0.75, this.headerBg.y + this.headerBg.height * 0.68, 'QuicksandRegular', ABCyaPhaser.Localization.instance.getLocalizedString('instructions.tap_right'), 28, Phaser.GameObjects.BitmapText.ALIGN_LEFT).setOrigin(0.5)
        .setTintFill(0x005472);
      this.instructGroup.add(this.rightInstruct);

      this.rightArrow = ABCyaPhaser.Images.addImage(this.scale.width * 0.75, this.headerBg.y + this.headerBg.height * 0.75, 'Arrow_Right', this.instructGroup);

      this.centerLine = ABCyaPhaser.Images.addImage(this.scale.width / 2, 0, 'MiddleLine', this.instructGroup);
      this.centerLine.y = this.headerTitle.y + this.headerTitle.height + this.centerLine.height / 2;

      this.leftArrow.y = this.centerLine.y;
      this.rightArrow.y = this.centerLine.y;
    }
    else {
      this.lblInstruct = this.add.bitmapText(this.scale.width * 0.5, this.headerBg.y + this.headerBg.height * 0.55, 'QuicksandRegular', ABCyaPhaser.Localization.instance.getLocalizedString('instructions.tilt'), 32, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5)
        .setTintFill(0x005472);
      this.instructGroup.add(this.lblInstruct);

      this.exampleTablet = new TiltExample(this);
      this.add.existing(this.exampleTablet);

      this.exampleTablet.setOrigin(0.5, 1);
      this.exampleTablet.x = this.scale.width / 2;
      this.exampleTablet.y = this.scale.height / 2 + this.exampleTablet.height / 2;

      this.exampleTablet.visible = false;
    }

    this.setupBlank();
    this.startIntro();
  }

  setupBlank() {
    this.instructGroup.iterate(child => child.setVisible(false));
  }

  /* ANIMATIONS */
  startIntro() {
    this.headerBg.visible = true;

    const ttime = 1300;
    ABCyaPhaser.Tweens.addTween(this.headerBg, ttime, { y: this.headerBg.y , easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out, () => {
      if (!gameData.config.hasMotionControls) {
        this.introDT();
      }
      else {
        this.intro2();
      }
    });
    this.headerBg.y = -this.headerBg.height;
  }

  intro2() {
    this.headerTitle.visible = true;
    this.lblInstruct.visible = true;
    this.exampleTablet.visible = true;

    ABCyaPhaser.Tweens.addTween(this.headerTitle, 1300, { x: this.headerTitle.x , easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);
    ABCyaPhaser.Tweens.addTween(this.lblInstruct, 1300, { delay: 2000, x: this.lblInstruct.x }, Phaser.Math.Easing.Back.Out, () => {
      if (!gameData.config.hasMotionControls) {
        this.introDT();
      }
    });

    this.headerTitle.x = -this.headerTitle.width / 2;
    this.lblInstruct.x = this.headerBg.width + this.lblInstruct.width / 2;

    if (gameData.config.hasMotionControls) {
      ABCyaPhaser.Tweens.addTween(this.exampleTablet, 1200, { delay: 800, y: this.exampleTablet.y }, Phaser.Math.Easing.Back.Out, () => {
        this.showGo();
      });
      this.exampleTablet.y = this.scale.height + this.exampleTablet.height;
    }
  }

  introDT() {
    this.headerTitle.visible = true;
    ABCyaPhaser.Tweens.addTween(this.headerTitle, 1300, { x: this.headerTitle.x , easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);
    this.centerLine.visible = true;
    ABCyaPhaser.Tweens.addTween(this.centerLine, 800, { delay: 600, y: this.centerLine.y }, Phaser.Math.Easing.Quadratic.In, () => {
      this.showLeft();
    });

    this.headerTitle.x = -this.headerTitle.width / 2;
    this.centerLine.y = this.scale.height + this.centerLine.height;
  }

  showLeft() {
    this.leftArrow.visible = true;
    this.leftInstruct.visible = true;
    ABCyaPhaser.Tweens.addTween(this.leftInstruct, 800, { delay: 200, x: this.leftInstruct.x , easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);

    ABCyaPhaser.Tweens.addTween(this.leftArrow, 800, { delay: 200, x: this.leftArrow.x , easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out, () => {
      this.showRight();
    });

    this.leftInstruct.x = -this.leftInstruct.width;
    this.leftArrow.x = -this.leftInstruct.width;
  }

  showRight() {
    this.rightInstruct.visible = true;
    this.rightArrow.visible = true;
    this.keySprites.visible = true;
    ABCyaPhaser.Tweens.addTween(this.rightInstruct, 800, { x: this.rightInstruct.x , easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);

    ABCyaPhaser.Tweens.addTween(this.rightArrow, 800, { x: this.rightArrow.x , easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);
    ABCyaPhaser.Tweens.addTween(this.keySprites, 400, { delay: 800, y: this.keySprites.y, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out, () => {
      this.showGo();
    });

    this.rightInstruct.x = this.scale.width + this.rightInstruct.width;
    this.rightArrow.x = this.scale.width + this.rightInstruct.width;
    this.keySprites.y = this.headerBg.y + this.headerBg.height - this.keySprites.height / 2;
  }

  beginTiltDemo() {
    this.leftLast = false;
    this.tiltRight();
  }

  tiltLeft() {
    ABCyaPhaser.Tweens.addTween(this.exampleTablet, 1000, { angle: -18 }, Phaser.Math.Easing.Back.Out, () => {
      this.centerLeft();
    });
  }

  centerLeft() {
    if (this.leftLast) {
      this.leftLast = false;
      ABCyaPhaser.Tweens.addTween(this.exampleTablet, 800, { angle: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.centerFinish();
      });
    }
  }

  tiltRight() {
    ABCyaPhaser.Tweens.addTween(this.exampleTablet, 1000, { angle: 18 }, Phaser.Math.Easing.Back.Out, () => {
      this.centerRight();
    });
  }

  centerFinish() {
    if (this.leftLast) {
      this.tiltLeft();
    }
    else {
      this.tiltRight();
    }
  }

  centerRight() {
    if (!this.leftLast) {
      this.leftLast = true;

      ABCyaPhaser.Tweens.addTween(this.exampleTablet, 800, { angle: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.centerFinish();
      });
    }
  }

  showGo() {
    const y = 900;
    this.btnStart = this.add.container(this.scale.width / 2, y);
    ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'BUTTON_quit', 'BUTTON_quitDWN', () => this.handleStartRelease(), this.btnStart, { pressAnimationConfig: null, releaseAnimationConfig: null });
    const btnStartTxt = this.add.bitmapText(0,0, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.start'), 46, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5)
      .setTintFill(0xefa02e);
    this.btnStart.add(btnStartTxt);
    ABCyaPhaser.Text.resizeFontToFitWidth(btnStartTxt, 125, 50);

    this.btnStart.scale = 0;
    ABCyaPhaser.Tweens.addTween(this.btnStart, 740, { delay: 340, scale: 1, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);

    if (gameData.config.hasMotionControls) this.beginTiltDemo();
  }

  handleStartRelease() {
    this.btnStart.disableInteractive();

    ABCyaPhaser.Tweens.addTween(this.btnStart, 840, { scale: 0, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.In);
    ABCyaPhaser.Tweens.addTween(this.instructGroup, 1300, { y: -this.instructGroup.getBounds().height - this.headerBg.y - this.headerBg.y, delay: 700 }, Phaser.Math.Easing.Back.In, () => this.nextScene());

    if (gameData.config.hasMotionControls) {
      ABCyaPhaser.Tweens.addTween(this.exampleTablet, 2000, { y: this.scale.height + this.exampleTablet.height, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.In);
    }
    else {
      ABCyaPhaser.Tweens.addTween(this.leftInstruct, 800, { delay: 200, x: -this.leftInstruct.width, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);
      ABCyaPhaser.Tweens.addTween(this.leftArrow, 800, { delay: 200, x: -this.leftInstruct.width, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);
      ABCyaPhaser.Tweens.addTween(this.rightInstruct, 800, { x: this.scale.width + this.rightInstruct.width, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);
      ABCyaPhaser.Tweens.addTween(this.rightArrow, 800, { x: this.scale.width + this.rightInstruct.width, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);
      ABCyaPhaser.Tweens.addTween(this.centerLine, 800, { delay: 600, y: this.scale.height + this.centerLine.height, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out, () => {
        this.centerLine.setActive(false).setVisible(false);
      });
    }
  }

  nextScene() {
    this.scene.start('PlayScene');
  }
}